<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      height="100"
    >
      

      <v-toolbar-title class="d-none d-md-flex">
        <v-row>
          <v-col cols="12 mb-0 pb-0">
            <h2 class="font-weight-black">CIRCUITO DE PALESTRAS DE COMPUTAÇÃO</h2>
          </v-col>
          <v-col cols="12 pt-0 mt-0">
            <span class="text-md-subtitle-1 font-weight-bold"> IFRS - IBIRUBÁ/RS - 20 a 24/07/2020 e 27 a 31/07/2020</span>
          </v-col>
        </v-row>
         
      </v-toolbar-title>

      <v-toolbar-title class="d-flex d-sm-none d-none d-sm-flex d-md-none font-weight-black text-sm-body-1 headline">
        Circuito de Palestras<br>IFRS - Ibirubá
      </v-toolbar-title>
    
    
    
    </v-app-bar>

    <v-content>
      
      <v-sheet
        id="contact"
        color="#333333"
        dark
        tag="section"
        tile
      >
        <div class="py-12"></div>

        <v-container>
          <v-responsive class="mx-auto mb-12">
            <h2 class="text-md-h2 text-sm-body-2 text-lg-h2 font-weight-bold mb-3 text-uppercase text-center">Assine sua presença</h2>
            <h4 class="text-center">Para receber certificado de participação (Frequência mínima de 75%).</h4>
          </v-responsive>

          <v-responsive class="mx-auto mb-12">
            <v-alert
              outlined
              color="yellow"
              border="bottom"
            >
              <h3><v-icon color="yellow">mdi-information-outline</v-icon> Quanto tempo terei para assinar a presença?</h3>
              <h4>Você poderá assistir e assinar sua presença até <strong>07/08/2020</strong>.</h4>

            </v-alert>
          </v-responsive>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-theme-provider dark>
            <v-form ref="form" v-model="valid" name="inscricao" >
            <v-row>
              
              <v-col cols="12">
                <v-text-field
                  outlined
                  white
                  label="Email do Usuário*"
                  v-model="presenca.usuarioEmail"
                  :rules="emailRules"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <label>
                  Qualidade da transmissão (Youtube)/formato (remoto):
                </label>
                <v-rating
                  background-color="orange lighten-3"
                  color="orange"
                  large
                  label="Qualidade da transmissão/formato"
                  v-model="presenca.palestraRatingTransmissao"
                ></v-rating>
              </v-col>

              <v-col cols="12"> 
                <label>
                  Tema da palestra:
                </label>
                <v-rating
                  background-color="orange lighten-3"
                  color="orange"
                  large
                  label="Qualidade da transmissão/formato"
                  v-model="presenca.palestraRatingPalestra"
                ></v-rating>
              </v-col>

              <v-col cols="12"> 
                <label>
                  Tempo de duração da palestra:
                </label>
                <v-slider
                  v-model="presenca.palestraRatingDuracao"
                  :tick-labels="duracoes"
                  max="2"
                  ticks="always"
                  tick-size="3"
                  color="orange"
                >
                <template v-slot:thumb-label="props">
                  <v-icon dark>
                    {{ duracaoIcone(props.value) }}
                  </v-icon>
                </template>
                </v-slider>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  outlined
                  white
                  label="Comentários/Sugestões"
                  v-model="presenca.palestraComentario"
                ></v-textarea>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  outlined
                  disabled
                  label="Palestra*"
                  v-model="presenca.palestraTitulo"
                  :rules="palestraRules"
                  required
                ></v-text-field>
              </v-col>
              
              <v-col cols="12">
                <v-text-field
                  outlined
                  disabled
                  label="Data da Assinatura*"
                  v-model="presenca.dataAssinatura"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  outlined
                  disabled
                  label="Endereço IP do usuário*"
                  v-model="presenca.usuarioIp"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  outlined
                  disabled
                  label="Browser do usuário*"
                  v-model="presenca.usuarioNavegador"
                  required
                ></v-text-field>
              </v-col>

              <v-col
                class="mx-auto"
                cols="auto"
              >
                <v-btn
                  color="accent"
                  x-large
                  @click="enviar"
                  :disabled="!valid"
                >
                  Enviar
                </v-btn>
              </v-col>
            </v-row>
            </v-form>
          </v-theme-provider>
        </v-container>

        <div class="py-12"></div>
      </v-sheet>
    </v-content>

    <v-dialog
      v-model="dialog"
      max-width="450"
    >
      <v-card>
        <v-card-title class="headline">Confirmação de Presença</v-card-title>

        <v-card-text v-if="cadastroSucesso">
          Sua presença foi salva com sucesso!
        </v-card-text>
        <v-card-text v-else>
          Houve algum problema ao processar sua presença!<br><br>
          <b>Descrição do erro:</b><br> {{erro}}
        </v-card-text>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogCodigoErrado"
      max-width="450"
      persistent
    >
      <v-card>
        <v-card-title class="headline">Houve algum problema!</v-card-title>
        <v-card-text>
          O código da sua palestra é inválido!
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-footer
      class="justify-center"
      color="#292929"
      height="100"
    >
      <div class="title font-weight-light grey--text text--lighten-1 text-center">
        &copy; {{ (new Date()).getFullYear() }} — Computação - IFRS - Ibirubá
      </div>
    </v-footer>
  </v-app>
</template>

<script>
//import VueRecaptcha from 'vue-recaptcha';
//import moment from 'moment'

export default {
  name: 'App',

  //components: { VueRecaptcha },

  data: () => ({
    dialog: false,
    dialogCodigoErrado: false,
    cadastroSucesso: false,
    valid: true,
    erro: '',
    duracoes: ['Curto','Adequado','Longo'],
    icones: [
        'mdi-timer-sand-empty',
        'mdi-timer-sand',
        'mdi-timer-sand-full',
    ],
    palestraRules: [
      v => !!v || 'Palestra é obrigatório',
    ],
    emailRules: [
      v => !!v || 'E-mail é obrigatório',
      v => /.+@.+\..+/.test(v) || 'E-mail deve ser válido',
    ],
    presenca: {
      palestraId: '',
      palestraTitulo: '',
      palestraData: '',
      palestraRatingTransmissao: 5,
      palestraRatingPalestra: 5,
      palestraRatingDuracao: 1,
      palestraComentario: '',
      usuarioEmail: '',
      usuarioIp: '',
      usuarioNavegador: '',
      dataAssinatura: '',
    },
    palestras: [
      {id: '11987', icone: 'mdi-svg', nome: 'Rogers Prates de Pelle', origem: '(UEMS)', data: '20/07/2020 às 19h', texto: 'Uma reflexão sobre como a pandemia acelerou um movimento natural no mundo corporativo e acadêmico.'},
      {id: '22876', icone: 'mdi-atom', nome: 'Alexandre Zamberlan', origem: '(UFN)', data: '21/07/2020 às 19h', texto: 'Computação e Nanotecnologia'},
      {id: '33765', icone: 'mdi-home-automation', nome: 'Fernando Marcondes', origem: '(Compasso - Passo Fundo)', data: '22/07/2020 às 19h', texto: 'Reinvenção no modelo de trabalho durante a pandemia'},
      {id: '44654', icone: 'mdi-traffic-light', nome: 'Lúcio Lopes Diniz', origem: '(Senac)', data: '23/07/2020 às 19h', texto: 'A importância do Teste de Software para a qualidade dos Sistemas'},
      {id: '55543', icone: 'mdi-stethoscope', nome: 'José Eduardo Venson', origem: '(Grupo Cura)', data: '24/07/2020 às 19h', texto: 'Como desenvolver carreira de computação na área da saúde'},
      {id: '66432', icone: 'mdi-lead-pencil', nome: 'Lisiane Oliveira', origem: '(IFRS/Unisinos)', data: '27/07/2020 às 19h', texto: 'Territórios de Inventar: Computação e a Educação OnLIFE'},
      {id: '77321', icone: 'mdi-matrix', nome: 'Ernando Silva', origem: '(Stefanini Scala)', data: '28/07/2020 às 19h', texto: 'Business Intelligence: conceitos, ferramentas, aplicações e tendências'},
      {id: '88210', icone: 'mdi-flower', nome: 'Roberto Wiest', origem: '(IFSUL - Passo Fundo)', data: '29/07/2020 às 19h', texto: 'Computação e Agro: Pesquisas e Oportunidades'},
      {id: '99109', icone: 'mdi-robot', nome: 'Joel Luís Carbonera', origem: '(UFRGS)', data: '30/07/2020 às 19h', texto: 'Inteligência Artificial'},
      {id: '00098', icone: 'mdi-tablet-ipad', nome: 'Eliane Schlemmer', origem: '(Unisinos)', data: '31/07/2020 às 19h', texto: 'Ecossistemas de Inovação na Educação OnLIFE'},
    ],
  }),

  created: function () {
    if(this.$route.params.id != undefined){
        this.presenca.palestraId = this.$route.params.id
        var palestraSelecionada = this.palestras.find(item => item.id === this.$route.params.id);
        
        if(palestraSelecionada != undefined){
          this.presenca.palestraTitulo = palestraSelecionada.nome + " - " + palestraSelecionada.texto + " - " + palestraSelecionada.data
          this.presenca.palestraData = palestraSelecionada.data
          this.presenca.dataAssinatura = new Date() //  moment(new Date()).format('DD/MM/YYYY h:m:s')
          this.$http.get("https://www.cloudflare.com/cdn-cgi/trace")
            .then(response => {
              this.presenca.usuarioIp = response.data.substring(response.data.search('ip=')+3, response.data.search('ts='))
              this.presenca.usuarioNavegador = response.data.substring(response.data.search('uag=')+4, response.data.search('colo='));
            })
        }else{
          this.dialogCodigoErrado = true
        }
    }else{
      this.dialogCodigoErrado = true
    }
    
  },

  methods: {
    enviar(){
      if( this.presenca.palestra == "" || this.presenca.email == ""){
        this.cadastroSucesso = false
        this.erro = "Campo obrigatório não preenchido"
        this.dialog = true
      }else{
        //this.$recaptcha("inscricao").then(() => {
            this.$http.post('presenca.json', this.presenca).then(res => {
                console.log(res)
                this.presenca.usuarioEmail = ""
                this.presenca.palestraComentario = ''
                this.presenca.palestraRatingTransmissao = 5
                this.presenca.palestraRatingPalestra = 5
                this.presenca.palestraRatingDuracao = 1
                this.$refs.form.resetValidation()
                this.cadastroSucesso = true
                this.dialog = true 
              })
              .catch(error => {
                console.log(error)
                this.cadastroSucesso = false
                this.erro = error
                this.dialog = true
              })
        //})  
      }    
    },
    
    duracaoIcone(val) {
      return this.icones[val]
    },
  }
};
</script>
